<template>
  <div>
        <div id="modalConsecutivo" class="modal">
      <div class="modal-contenido   rounded-xl p-5 mt-15">
        <div class="grid grid-cols-6 justify-items-end">
          <button
            type="button"
            class="w-12 h-10 col-start-6 end bg-red-500 rounded-md border shadow-3xl py-1"
          >
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="col-span-1 lg:col-span-6">
          <h4
            class="bg-gray-100 text-3xl mt-1 shadow-xl text-black text-center mt-5 mt-1 rounded divide-y divide-red-500 mb-5"
          >
            Consecutivo
            <hr color="black" size="4" />
          </h4>
          <p class="text-red text-xs italic">
            Por favor complete todos los campos
          </p>
        </div>
        <div
          class="border rounded-xl mt-5 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >
          <form action="submit">
            <div
              class="grid grid-cols-1 m-2 sm:grid-cols-2 md:grid-cols-3 md:w-full m-3 lg:grid-cols-2"
            >
              <div class="col-span-2 justify-center">
                <label
                  class="block uppercase tracking-wide text-grey-darker text-xs font-bold mb-2"
                  for=""
                >
               
                </label>

                <input
                v-model="nombre"
                  class="appearance-none mx-2 border w-80  ring-1 shadow-xl block col-span-1 bg-gray-lighter text-grey-darker  rounded py-3 "
                  id=""
                  type="text"
                  placeholder="Digite la Categoria "
                />
              </div>
             

              <div class="col-span-1 mx-2">
                <button
                  type="button"
                  class="w-full mt-10 inline-flex justify-items-end rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  <a href="#">Cancelar</a>
                </button>
              </div>
              <div class="col-span-1 mx-2">
                <button
                  type="button"
                  @click="sendUserData()"
                  @keyup.enter="sendUserData()"
                  class="w-full inline-flex justify-center mt-10 rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Guardar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
name:'modalConsecutivo'
}
</script>

<style>
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalConsecutivo:target {
  opacity: 1;
  pointer-events: auto;
}
</style>


